// extracted by mini-css-extract-plugin
module.exports = {"container":"BigTitle_container__3KgiV","title":"BigTitle_title__12oZE"};